import React from 'react'

import { maxSecond } from 'constants/params'

import classes from './styles'

class Score extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showAnimationClass: props.lastScoreModification !== 0 && !props.isTestEnd,
    }

    this.timeoutId = null
  }

  componentWillUnmount = () => {
    clearTimeout(this.timeoutId)
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.score === this.props.score) return

    this.setState({ showAnimationClass: true })

    this.timeoutId = setTimeout(() => {
      this.setState({ showAnimationClass: false })
    }, 200)
  }

  render() {
    const { lastScoreModification, score, timer } = this.props

    const scoreColorClass = (function() {
      if (lastScoreModification === 0) return ''
      return lastScoreModification > 0 ? classes.scorePlus : classes.scoreMinus
    })()

    const animationClass = this.state.showAnimationClass ? classes.animation + ' shake shake-constant' : ''

    const scoreBlockStyle = score >= 0 && score < 10 ? { width: '19px' } : {}

    return (
      <div className={classes.header}>

        <div className={classes.parameterBox}>
          <div className={classes.timerWrapper}>
            <h3 className={classes.parameter}>{maxSecond - timer}</h3>
          </div>
          <div className={classes.parameterTitle}>Время</div>
        </div>

        <div className={classes.parameterBox}>
          <div style={scoreBlockStyle} className={classes.scoreBlock}>
            <div className={classes.scoreWrapper}>
              <h3
                className={[classes.parameter, classes.score, scoreColorClass, animationClass].join(' ')}
              >{score}</h3>
            </div>
          </div>
          <div className={classes.parameterTitle}>Счет</div>
        </div>


      </div>
    )
  }
}

Score.propTypes = {
  timer: React.PropTypes.number.isRequired,
  lastScoreModification: React.PropTypes.number.isRequired,
  score: React.PropTypes.number.isRequired,
}

export default Score


// WEBPACK FOOTER //
// ./src/components/Score/Score.jsx